import { Screens } from 'src/app/core/enums/role-permissions.enum';

export interface SideNavIcon {
  icon?: string;
  displayText: string;
  iconType: SideNavType;
  route: Screens;
}

export enum SideNavType {
  ROUTE,
  SUB_ROUTE,
  DISPLAY_ONLY,
}

export const LOGOUT_INFO = {
  displayText: $localize`Logout`,
  icon: 'assets/sidebar-icons/logout.svg',
  route: Screens.LOGOUT,
};

const ADMIN_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.ADMIN_SEARCH,
    displayText: $localize`Admin Search`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.USER_ADMIN,
    displayText: $localize`User Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.LOCATION_ADMIN,
    displayText: $localize`Location Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.LOCATION_GROUP,
    displayText: $localize`Location Group`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.ROUTE_ADMIN,
    displayText: $localize`Route Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.DEVICE_ADMIN,
    displayText: $localize`Device Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.ADL,
    displayText: $localize`Access Point/ADL`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.BUILDING_SCAN_ADMIN,
    displayText: $localize`Building Scan Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const OPERATION_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.ROUTE_SUMMARY,
    displayText: $localize`Route Summary`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.PICKUP_ASSIGNMENT,
    displayText: $localize`Pickup Assignments`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const EXCEPTIONS_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.BUILDING_SCAN_EXCEPTIONS,
    displayText: $localize`Building Scan`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.INTERCEPTS,
    displayText: $localize`Intercepts`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.EXCEPTIONS,
    displayText: $localize`Exceptions`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.PRINT_SHIPPING_LABEL,
    displayText: $localize`Print Shipping Label`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

export const CLOSED_SIDENAV_VALUES: SideNavIcon[] = [
  {
    icon: 'assets/sidebar-icons/home.svg',
    displayText: $localize`Home`,
    iconType: SideNavType.ROUTE,
    route: Screens.HOME,
  },
  {
    displayText: $localize`Admin`,
    icon: 'assets/sidebar-icons/people.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.ADMIN,
  },
  {
    displayText: $localize`Operations`,
    icon: 'assets/sidebar-icons/truck.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.OPERATIONS,
  },
  {
    displayText: $localize`Exceptions`,
    icon: 'assets/sidebar-icons/building.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.EXCEPTIONS_GROUP,
  },
  {
    displayText: $localize`Reports`,
    icon: 'assets/sidebar-icons/file.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.REPORTS,
  },
  {
    displayText: $localize`File Upload`,
    icon: 'assets/sidebar-icons/white_upload_file.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.FILE_UPLOAD,
  },
];

export const OPEN_SIDENAV_VALUES: SideNavIcon[] = [
  {
    icon: 'assets/sidebar-icons/home.svg',
    displayText: $localize`Home`,
    iconType: SideNavType.ROUTE,
    route: Screens.HOME,
  },
  {
    displayText: $localize`Admin`,
    icon: 'assets/sidebar-icons/people.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.ADMIN,
  },
  ...ADMIN_SUB_VALUES,
  {
    displayText: $localize`Operations`,
    icon: 'assets/sidebar-icons/truck.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.OPERATIONS,
  },
  ...OPERATION_SUB_VALUES,
  {
    displayText: $localize`Exceptions`,
    icon: 'assets/sidebar-icons/building.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.EXCEPTIONS_GROUP,
  },
  ...EXCEPTIONS_SUB_VALUES,
  {
    displayText: $localize`Reports`,
    icon: 'assets/sidebar-icons/file.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.REPORTS,
  },
  {
    displayText: $localize`File Upload`,
    icon: 'assets/sidebar-icons/white_upload_file.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.FILE_UPLOAD,
  },
];
